/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  WamplLoanRouter,
  WamplLoanRouterInterface,
} from "../WamplLoanRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ILoanRouter",
        name: "_loanRouter",
        type: "address",
      },
      {
        internalType: "contract IWAMPL",
        name: "_wampl",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ampl",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "loanRouter",
    outputs: [
      {
        internalType: "contract ILoanRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wampl",
    outputs: [
      {
        internalType: "contract IWAMPL",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amplAmount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "sales",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "wrapAndBorrow",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amplAmount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "wrapAndBorrowMax",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type WamplLoanRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WamplLoanRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WamplLoanRouter__factory extends ContractFactory {
  constructor(...args: WamplLoanRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _loanRouter: PromiseOrValue<string>,
    _wampl: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<WamplLoanRouter> {
    return super.deploy(
      _loanRouter,
      _wampl,
      overrides || {}
    ) as Promise<WamplLoanRouter>;
  }
  override getDeployTransaction(
    _loanRouter: PromiseOrValue<string>,
    _wampl: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_loanRouter, _wampl, overrides || {});
  }
  override attach(address: string): WamplLoanRouter {
    return super.attach(address) as WamplLoanRouter;
  }
  override connect(signer: Signer): WamplLoanRouter__factory {
    return super.connect(signer) as WamplLoanRouter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WamplLoanRouterInterface {
    return new utils.Interface(_abi) as WamplLoanRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WamplLoanRouter {
    return new Contract(address, _abi, signerOrProvider) as WamplLoanRouter;
  }
}
